<template>
  <div class="rounded d-flex align-items-center bg-danger px-5 m-2">
    <h5 class="my-0 text-white text-center mx-auto">
      {{ `ENTORNO DE ${isPreproduction() ? 'PREPRODUCTIVO' : 'DESARROLLO'}` }}
    </h5>
  </div>
</template>

<script>
export default {
  methods: {
    isPreproduction() {
      return import.meta.env.VITE_ENVIROMENT == 'preproduction'
    }
  }
}
</script>

<style></style>
